<template>
    <Card>
        <Row :gutter="16">
            <Col span="24">
            <div class="global-tool-bar">
                <div class="left-bar">
                    <span class="title">支付管理</span>
                </div>
                <div class="right-bar">
                    <Button size="small"
                        class="btns"
                        shape="circle"
                        type="success"
                        icon="ios-add-circle-outline"
                        @click="onAreaCreate">新增</Button>
                </div>
            </div>
            </Col>
        </Row>
        <Modal v-model="payConfigFormShow"
            title="银行信息">
            <Form label-position="top">
                <Row :gutter="16">
                    <Col span="24">
                    <FormItem label="银行名称">
                        <Select v-model="payConfigForm.payPlatformUuid"  transfer v-if="formEditModeIsCreate">
								<Option v-for="item in payConfigResource" :key="item.payPlatformUuid"
									:value="item.payPlatformUuid">{{ item.platformName }} </Option>
						</Select>
                      <Input v-model="payConfigForm.platformName" disabled v-if="!formEditModeIsCreate"></Input>
                    </FormItem>
                    </Col>
                    <Col span="24">
                    <FormItem label="支付状态" v-if="!formEditModeIsCreate">
                        <Select v-model="payConfigForm.platformConfigStatus"  transfer >
								<Option v-for="item in platformConfigStatusResource"  :key="item.Status"
									:value="item.Status">{{ item.text }} </Option>
						</Select>
                    </FormItem>
                    </Col>
                   
                    <Col span="24">
                    <FormItem label="备注">
                        <Input v-model="payConfigForm.platformConfigRemark"></Input>
                    </FormItem>
                    </Col> 
                </Row>
            </Form>
            <div slot="footer">
                <Button type="success"
                    class="form-button"
                    @click="onSave">保存</Button>
                <Button type="text"
                    class="form-button"
                    @click="onCancel">取消</Button>
            </div>
        </Modal>

        <Row :gutter="16">
            <Col span="24">
            <stand-pagination-table :columns="mainTable.columns"
                :data="mainTable.data"
                :loading="mainTable.loading"
                :table-search="mainTable.tableSearch"
                :table-load-event="getAreaTableRecords" />
            </Col>
        </Row>
    </Card>
</template>

<script>
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';

import { getPayPlatformConfigList, savePayPlatformConfig, getPayPlatformList } from '@/api/modules/system-management/pay-management';


export default {
  
    components: {
        StandPaginationTable
    },
    data() {
        return {
            payConfigForm: {
                formEditMode: '',
                payPlatformUuid: '',
                platformConfigStatus: '',           
                platformConfigRemark: ''
            },
            payConfigResource:[],
            platformConfigStatusResource: [{ Status: 1, text: '是' }, { Status: 0, text: '否' }],
            payConfigFormShow: false,
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 80, align: 'center' },
                    { title: '支付平台', key: 'platformName', align: 'center' },
                    { title: '是否允许支付', key: 'platformConfigStatus', align: 'center',         
                        render: (h, params) => {
                            return h('div', params.row.platformConfigStatus==1?'是':'否');
                        } },
                    { title: '操作人', key: 'userPersonName', align: 'center' },
                    { title: '备注', key: 'platformConfigRemark', align: 'center' },
                    {
                        title: '修改支付状态',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.onPayUpdate(params.row);
                                        }
                                    }
                                }, '修改')]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getAreaTableRecords();
        this.getPayPlatformList();
    },
    computed: {
        ConfigStatusText() {
     
            return this.payConfigForm.platformConfigStatus == 1 ? "是" : "否";
        },
        formEditModeIsCreate() {
            return this.payConfigForm.formEditMode == FORM_EDIT_MODE_CREATE;
        }
    },
    methods: {
        getAreaTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getPayPlatformConfigList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            }).catch(() => {
                this.mainTable.tableLoading = false;
            });
        },
        getPayPlatformList(){
            getPayPlatformList({ isNoConfigHas:true }).then(res=>{
                if (res.code === 0) {
                    this.payConfigResource=res.data.records;
                }
            });
        },
   
        onAreaCreate() {
            this.payConfigForm.formEditMode = FORM_EDIT_MODE_CREATE;
            this.payConfigForm.payPlatformUuid='';
            this.payConfigForm.platformConfigStatus= 1;          
            this.payConfigForm.platformConfigRemark='';
            this.payConfigFormShow = true;
        },
  
        onPayUpdate(row) {
            this.payConfigForm.formEditMode = FORM_EDIT_MODE_MODIFY;
            this.payConfigForm.payPlatformUuid = row.payPlatformUuid;
            this.payConfigForm.platformConfigStatus = row.platformConfigStatus;
            this.payConfigForm.platformName=row.platformName;
            this.payConfigForm.platformConfigRemark = '';
            
            this.payConfigFormShow = true;
        },
        onCancel() {
            this.payConfigFormShow = false;
        },
        onSave() {
      
            savePayPlatformConfig(this.payConfigForm).then(res => {
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.payConfigFormShow = false;
                            window.location.reload();
                        }
                    });
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
</style>
